// extracted by extract-css-chunks-webpack-plugin
module.exports = {"list":"app-components-usersong-dropdown--list"};